import type { Translate } from 'next-translate';
import React from 'react';
import { Container } from '@/components/elements/Container';
import { MotionMyImage, MyImage } from '@/components/elements/MyImage';
import { ButtonGroup } from '@/components/landing/blocks';
import type { LandingConfigItem } from '@/types';
import { pictureMotion } from '@/animations';
import bg from '@/public/images/landing/backgrounds/bgProductivity.webp';
import styles from './TryLift.module.scss';

interface TryLiftProps {
	data: LandingConfigItem['tryLift'];
	t: Translate;
}
export const TryLift: React.FC<TryLiftProps> = ({ data, t }) => {
	// Destructuring
	const { data: info, images } = data;
	const { title1, title2, description, accentText } = info;

	return (
		<section className={styles['try']} aria-labelledby='try-title'>
			<Container className={`container ${styles['try__container']}`}>
				<div className={styles['try__info']}>
					<MyImage
						imageProps={{
							src: bg,
							alt: 'Stylized gradient background',
							title: 'Stylized gradient background',
							loading: 'lazy',
						}}
						settings={{
							classes: {
								picture: `${styles['try__background']}`,
								image: styles['try__background-img'],
							},
						}}
					/>

					<h2 className={`${styles['try__title']}`} id='try-title'>
						{t(title1)}
						<span className={`${styles['try__title-green']}`}>
							{t(accentText)}
						</span>
						{t(title2)}
					</h2>
					<p className={`${styles['try__subtitle']}`}>{t(description)}</p>

					<MotionMyImage
						{...pictureMotion}
						imageProps={{
							src: images[0].image,
							alt: t(images[0].alt),
							title: t(images[0].title),
							loading: 'lazy',
						}}
						settings={{
							classes: {
								picture: styles['try__picture'],
								image: styles['try__image'],
							},
						}}
					/>

					<ButtonGroup
						preset='landing_outline'
						classes={{
							blockClass: styles['try__apps'],
						}}
					/>
				</div>
			</Container>
		</section>
	);
};
